"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnNlUsd = exports.EnNlEur = exports.NlNlUsd = exports.NlNlEur = void 0;
class NlNlEur {
    constructor() {
        this.locale = "nl-nl";
        this.dateFormat = {
            short: "dd-MM-yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.NlNlEur = NlNlEur;
class NlNlUsd {
    constructor() {
        this.locale = "nl-nl";
        this.dateFormat = {
            short: "dd-MM-yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.NlNlUsd = NlNlUsd;
class EnNlEur {
    constructor() {
        this.locale = "en-nl";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnNlEur = EnNlEur;
class EnNlUsd {
    constructor() {
        this.locale = "en-nl";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnNlUsd = EnNlUsd;
